<template>
  <div>

    <header class="header">
      <h1 class="header__title">ParkAve Administrator Controls</h1>
      <section class="header__area">
      </section>
    </header>

    <nav class="tabs">
      <router-link v-if="me.admin || me.format_admin" @click.native="checkCurrent('admin-categories')" to="#categories" class="tabs__tab tab" :class="{'tab--active': currentDisplay === 'admin-categories'}">Categories</router-link>
      <router-link v-if="me.admin" @click.native="checkCurrent('admin-accounts')" to="#accounts" class="tabs__tab tab" :class="{'tab--active': currentDisplay === 'admin-accounts'}" >Accounts</router-link>
      <router-link v-if="me.admin || me.format_admin" @click.native="checkCurrent('admin-formats')" to="#formats" class="tabs__tab tab" :class="{'tab--active': currentDisplay === 'admin-formats'}" >Formats</router-link>
      <router-link v-if="me.admin" @click.native="checkCurrent('admin-coupons')" to="#coupons" class="tabs__tab tab" :class="{'tab--active': currentDisplay === 'admin-coupons'}" >Coupons</router-link>
      <router-link v-if="me.admin" @click.native="checkCurrent('admin-users')" to="#users" class="tabs__tab tab" :class="{'tab--active': currentDisplay === 'admin-users'}" >Users</router-link>
    </nav>

    <section class="main-content main-content--white-background">
      <section class="main-content__full section">
        <component :is="currentDisplay"></component>
      </section>
    </section>

  </div>
</template>

<script>
    import AdminCategories from './admin/AdminCategories'
    import AdminAccounts from './admin/AdminAccounts'
    import AdminFormats from './admin/AdminFormats'
    import AdminCoupons from './admin/AdminCoupons'
    import AdminUsers from './admin/AdminUsers'
    import store from '../store'

    export default {
      name: 'Administrator',
      components: {
        'admin-categories': AdminCategories,
        'admin-accounts': AdminAccounts,
        'admin-formats': AdminFormats,
        'admin-coupons': AdminCoupons,
        'admin-users': AdminUsers
      },
      beforeRouteEnter (to, from, next) {
        store.dispatch('loadMe')
          .then(() => {
            if (store.state.me.admin || store.state.me.format_admin) {
              next()
            } else {
              next(from.fullPath)
            }
          })
          .catch(() => {
            next({ name: 'Home', query: { redirect_to: from.fullPath } })
          })
      },
      mounted () {
        if (this.$route.hash.slice(1)) {
          this.current = 'admin-' + this.$route.hash.slice(1);
        }

        this.$store.dispatch('formats/loadAll');
        this.$store.dispatch('coupons/load');
        this.me = this.$store.state.me;
        if (this.me.admin) {
          this.$store.dispatch('accounts/loadAll');
          this.$store.dispatch('users/loadAll');
        }
      },
      data () {
        return {
          current: 'admin-categories',
          me: {}
        }
      },
      computed: {
        currentDisplay () {
          return this.current;
        }
      },
      methods: {
        checkCurrent (tab) {
          if (this.current === tab) {
            location.reload()
          } else {
            this.current = tab
          }
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import '../scss/index';
</style>




// WEBPACK FOOTER //
// src/components/Administrator.vue